import React from 'react';
export function TestimonialsSection() {
  return <div className="max-w-3xl mx-auto px-5 md:px-6 py-10" data-id="element-429">
      <hr className="border-t-2 border-dashed border-border-light mb-10" data-id="element-430" />

      <h2 className="font-serif text-2xl md:text-3xl font-bold text-dark text-center mb-4" data-id="element-431">
        Escucha Lo Que Dicen Quienes Ya Lo Tienen:
      </h2>
      <p className="text-center font-serif text-lg text-body-text mb-8" data-id="element-432">
        No quiero que confíes solo en mi palabra.
        <br data-id="element-433" />
        Mejor mira lo que dicen algunas familias que ya usan el Pack:
      </p>

      {/* Testimonial 1 */}
      <div className="bg-highlight-bg border-l-4 border-accent py-6 px-6 my-6 rounded-r-lg" data-id="element-434">
        <p className="font-serif text-lg font-bold text-dark mb-2" data-id="element-435">
          "La Mejor Colección de Actividades Que He Encontrado"
        </p>
        <p className="font-serif text-base text-body-text italic mb-3 leading-relaxed" data-id="element-436">
          "He comprado libros, seguido cuentas de Instagram y descargado PDFs
          gratuitos, y esto es claramente lo mejor que existe. Tiene ideas para
          cada mes, cada área, y todo explicado al detalle. Simplemente tienes
          que conseguir esto, especialmente si acabas de ser mamá o papá. Para
          lo que ofrece, es una ganga."
        </p>
        <p className="font-sans font-bold text-base text-dark" data-id="element-437">
          — Laura M., mamá primeriza, Madrid
        </p>
      </div>

      {/* Testimonial 2 */}
      <div className="bg-highlight-bg border-l-4 border-accent py-6 px-6 my-6 rounded-r-lg" data-id="element-438">
        <p className="font-serif text-lg font-bold text-dark mb-2" data-id="element-439">
          "Las Guías Son Facilísimas de Seguir, a Diferencia de Todo lo
          Demás..."
        </p>
        <p className="font-serif text-base text-body-text italic mb-3 leading-relaxed" data-id="element-440">
          "Recibí el pack hace unos días y no he podido parar de revisarlo. Hay
          fotos claras, descripciones detalladas de cada paso y todo organizado
          por edad. Estas guías superaron mis expectativas. Son súper fáciles de
          leer y entender, a diferencia de otros recursos que encontré en
          internet. ¡No puedo esperar para empezar!"
        </p>
        <p className="font-sans font-bold text-base text-dark" data-id="element-441">
          — Carlos R., papá de gemelos, Buenos Aires
        </p>
      </div>

      {/* Testimonial 3 */}
      <div className="bg-highlight-bg border-l-4 border-accent py-6 px-6 my-6 rounded-r-lg" data-id="element-442">
        <p className="font-serif text-lg font-bold text-dark mb-2" data-id="element-443">
          "Una Inversión Excelente Para Cualquier Familia"
        </p>
        <p className="font-serif text-base text-body-text italic mb-3 leading-relaxed" data-id="element-444">
          "De todo lo que he comprado sobre estimulación temprana a lo largo de
          los años, esta es la mejor colección. Es un recurso excelente tanto
          para padres primerizos como para abuelos o educadores. Me hubiera
          encantado tener esto cuando nació mi primer hijo. Considerando el
          contenido y la calidad, este paquete es realmente increíble."
        </p>
        <p className="font-sans font-bold text-base text-dark" data-id="element-445">
          — Marta G., abuela y educadora, Bogotá
        </p>
      </div>

      {/* Testimonial 4 */}
      <div className="bg-highlight-bg border-l-4 border-accent py-6 px-6 my-6 rounded-r-lg" data-id="element-446">
        <p className="font-serif text-lg font-bold text-dark mb-2" data-id="element-447">
          "Ya Había Sido Decepcionada Antes, Pero Esto Me Demostró Lo
          Contrario..."
        </p>
        <p className="font-serif text-base text-body-text italic mb-3 leading-relaxed" data-id="element-448">
          "Ya había comprado cosas que no valían la pena, así que dudé. Pero
          este pack me demostró que estaba equivocada y no podría estar más
          contenta. Para alguien que empieza, esto es un regalo del cielo porque
          tienes CADA detalle que necesitas. Si quieres estimular bien a tu
          hijo, te lo debes a ti misma."
        </p>
        <p className="font-sans font-bold text-base text-dark" data-id="element-449">
          — Valentina S., mamá, Santiago de Chile
        </p>
      </div>
    </div>;
}